import React from 'react';
import AddonItem from './AddonItem';
import { checkCorporateUser } from '../../../utils/commonFunctions';
import { ADD_ON_FEE_TYPE_VALUE } from '../../../containers/settings/AddonTemplate/utils/fieldAddonService';

const AddonSection = ({
  title,
  items,
  hideActionButtons = false,
  hideDivider = false,
  isIncluded = false,
  findEntry,
  onQuantityChange,
  onCustomValueChange,
  isEditFare = false,
  onValueEditFareChange,
  hideEnableButton = false,
  currencyISO,
  disabled = false,
  auth = {}
}) => {
  if (!items?.length) return null;

  const checkDisabledWithCorporateUser = (addon) => {
    if(checkCorporateUser(auth?.user)) {
      return addon.feeConfig?.type === ADD_ON_FEE_TYPE_VALUE.custom
    }
    return false
  }

  return (
    <div className="addon-section">
      {!hideDivider && <div className="addon-divider" />}
      <div className="addon-section__title">{title}</div>
      {items.map((item) => {
        const entry = findEntry(item.serviceId);
        return (
          <AddonItem
            key={item.serviceId}
            item={item}
            disabled={disabled || checkDisabledWithCorporateUser(item)}
            entry={entry}
            hideActionButtons={hideActionButtons}
            hideEnableButton={hideEnableButton}
            isIncluded={isIncluded}
            onQuantityChange={onQuantityChange}
            onCustomValueChange={onCustomValueChange}
            onValueEditFareChange={onValueEditFareChange}
            isEditFare={isEditFare}
            currencyISO={currencyISO}
          />
        );
      })}
    </div>
  );
};

export default AddonSection;

